import { connect } from 'react-redux';
import {
  actionDeleteLocation,
  actionExportLocationList,
  actionGetLocationList,
} from 'store/location/actions';
import { actionGetInternalAccountList } from 'store/manageAccount/actions';
import { actionGetMarketList } from 'store/market/actions';
import {
  actionClearLandmarkList,
  actionGetLandmarkList,
} from 'store/landmark/action';
import { CLOSE_MODAL } from 'store/global/modal/actionTypes';

import LocationList from './LocationList';

const mapStateToProps = (state) => ({
  isLoadingLocationList: state.Location.isLoadingLocationList,
  isLoadingExportLocationList: state.Location.isLoadingExportLocationList,
  isLoadingMarketList: state.Market.isLoadingMarketList,
  isLoadingLandmarkList: state.Landmark.isLoadingLandmarkList,
  isLoadingGetInternalAccountList: state.ManageAccount.isLoadingGetInternalAccountList,
  locationList: state.Location.locationList,
  totalLocation: state.Location.totalLocation,
  marketList: state.Market.marketList,
  marketTotal: state.Market.marketTotal,
  landmarkOptions: state.Landmark.landmarkOptions,
  internalAccountList: state.ManageAccount.internalAccountList,
  internalAccountTotal: state.ManageAccount.internalAccountTotal,

  modalType: state.Modal.modalType,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetLocationList: (payload) => dispatch(actionGetLocationList(payload)),

  actionExportLocationList: (payload) => dispatch(actionExportLocationList(payload)),

  actionDeleteLocation: (payload) => dispatch(actionDeleteLocation(payload)),

  actionCloseModalCreatePlaceSuccess: () =>
    dispatch({
      type: CLOSE_MODAL,
    }),

  actionGetMarketList: (payload) => dispatch(actionGetMarketList(payload)),

  actionGetLandmarkList: (payload) => dispatch(actionGetLandmarkList(payload)),

  actionClearLandmarkList: () => dispatch(actionClearLandmarkList()),

  actionGetInternalAccountList: (payload) =>
    dispatch(actionGetInternalAccountList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationList);
